import { forwardRef } from 'react';
import classNames from 'classnames';

import { Props } from './item.type';

export const Item = forwardRef<HTMLLIElement, Props>(
  ({ value, onClick, selected = false, onMouseEnter, onMouseLeave, isHovered }, ref) => {
    const handleClick = () => {
      onClick(value);
    };

    return (
      <li
        ref={ref}
        className={classNames('cursor-default select-none relative py-2 px-3', {
          'fill-primary-active': isHovered,
          'fill-primary': !isHovered && !selected,
          'fill-dark': !isHovered && selected,
        })}
        role='option'
        aria-selected={selected}
        onKeyDown={handleClick}
        onClick={handleClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}>
        <div className='flex items-center'>
          <span
            className={classNames('ml-3 block truncate', {
              'text-primary text-body-m': isHovered || (!isHovered && !selected),
              'text-negative': !isHovered && selected,
            })}>
            {value}
          </span>
        </div>
      </li>
    );
  }
);
